export enum BenchmarkStatus {
  Available = 'available',
  NotAvailable = 'not_available',
  AvailableWithDataCorrections = 'available_with_data_corrections',
  UnknownAndRequiresDataCorrections = 'unknown_and_requires_data_corrections'
}
